/* tslint:disable */
/* eslint-disable */
/**
 * Poolside API
 * Poolside API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiCompany,
    ApiCompanyFromJSON,
    ApiCompanyFromJSONTyped,
    ApiCompanyToJSON,
    ApiInvestorProfile,
    ApiInvestorProfileFromJSON,
    ApiInvestorProfileFromJSONTyped,
    ApiInvestorProfileToJSON,
    LimitedPartnerType,
    LimitedPartnerTypeFromJSON,
    LimitedPartnerTypeFromJSONTyped,
    LimitedPartnerTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApiLimitedPartner
 */
export interface ApiLimitedPartner {
    /**
     * 
     * @type {ApiInvestorProfile}
     * @memberof ApiLimitedPartner
     */
    person?: ApiInvestorProfile;
    /**
     * 
     * @type {ApiCompany}
     * @memberof ApiLimitedPartner
     */
    company?: ApiCompany;
    /**
     * 
     * @type {LimitedPartnerType}
     * @memberof ApiLimitedPartner
     */
    limitedPartnerType: LimitedPartnerType;
}

export function ApiLimitedPartnerFromJSON(json: any): ApiLimitedPartner {
    return ApiLimitedPartnerFromJSONTyped(json, false);
}

export function ApiLimitedPartnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiLimitedPartner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'person': !exists(json, 'person') ? undefined : ApiInvestorProfileFromJSON(json['person']),
        'company': !exists(json, 'company') ? undefined : ApiCompanyFromJSON(json['company']),
        'limitedPartnerType': LimitedPartnerTypeFromJSON(json['limitedPartnerType']),
    };
}

export function ApiLimitedPartnerToJSON(value?: ApiLimitedPartner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'person': ApiInvestorProfileToJSON(value.person),
        'company': ApiCompanyToJSON(value.company),
        'limitedPartnerType': LimitedPartnerTypeToJSON(value.limitedPartnerType),
    };
}

